import {setAccordionCrossClasses} from "../../shared/js/accordion";

const _throttle = require('lodash.throttle');

let lightboxLock = false;

function closeLightBox(lightbox) {
    if (lightboxLock) return;
    lightboxLock = true;
    lightbox.dataset.visible = 'false';

    setTimeout(() => {
        lightbox.dataset.hidden = 'true';
        lightboxLock = false;
    }, 300);
}

function openLightBox(lightbox) {
    if (lightboxLock) return;
    lightboxLock = true;
    lightbox.dataset.hidden = 'false';

    setTimeout(() => {
        lightbox.dataset.visible = 'true';
        lightboxLock = false; // Release lock after animation
    }, 50);
}

const documentKeydownHandler = _throttle((event, lightbox, splide) => {
    if (!lightbox.classList.contains('hidden')) {
        if (event.key === 'Escape') {
            closeLightBox(lightbox);
        } else if (event.key === 'ArrowRight') {
            splide.go('+1');
        } else if (event.key === 'ArrowLeft') {
            splide.go('-1');
        }
    }
}, 300); // Adjust throttle interval as needed

window.addEventListener('load', () => {
    let availableCarousels = document.querySelectorAll('.splide');
    let homeHeroSplidePanel = document.querySelectorAll('.home-hero-slide-panel');
    let eventSelectorPanel = document.querySelectorAll('.event-selector-panel');
    const cardPanel = document.querySelectorAll('.card-panel-slider');
    const gallerySplidePanel = document.querySelectorAll('.gallery-panel');

    if (availableCarousels.length) {
        // START GALLERY PANEL SLIDER
        for ( let panel of gallerySplidePanel ) {
            const galleryThumbnails = panel.querySelectorAll('.gallery-panel-image');
            const totalSlides = Number(panel.querySelector('.gallery-splide').dataset.totalSlides);
            const lightbox = panel.querySelector('[data-lightbox="gallery-panel"]');
            const requiredSplidesPresent = (panel.querySelector('.gallery-lightbox-splide') && panel.querySelector('.gallery-splide'));
            const destroySlideDesktop = panel.querySelector('.gallery-splide').dataset.destroySplideDesktop === 'true';
            const paginationColor = panel.querySelector('.gallery-splide').dataset.paginationColor;
            const paginationActiveColor = panel.querySelector('.gallery-splide').dataset.paginationActiveColor;
            const paginationBorderColor = panel.querySelector('.gallery-splide').dataset.paginationBorderColor;
            const arrowColor = panel.querySelector('.gallery-splide').dataset.arrowColor;

            if (requiredSplidesPresent) {
                let galleryLightboxSplide = null;
                const galleryLightboxSplideElement = panel.querySelector('.gallery-lightbox-splide');
                if (galleryLightboxSplideElement) {
                    galleryLightboxSplide = new Splide(galleryLightboxSplideElement, {
                        type: 'fade',
                        speed: 750,
                        arrows: true,
                        pagination: false,
                        arrowPath: 'M2.68456 22.7027L30.604 22.7027L17.9866 35.4054C16.9128 36.4865 16.9128 38.1081 17.9866 39.1892C19.0604 40.2703 20.6711 40.2703 21.745 39.1892L39.1946 21.8919C39.1946 21.6216 39.4631 21.3514 39.7315 21.0811C39.7315 20.8108 40 20.5405 40 20C40 19.7297 40 19.1892 39.7315 18.9189C39.4631 18.6487 39.1946 18.3784 39.1946 18.1081L21.745 0.810811C20.6711 -0.27027 19.0604 -0.27027 17.9866 0.810811C16.9128 1.89189 16.9128 3.51351 17.9866 4.59459L30.604 17.2973L2.68456 17.2973C1.07382 17.2973 1.41767e-07 18.3784 0 20C-1.41766e-07 21.6216 1.34228 22.7027 2.68456 22.7027Z',
                        classes: {
                            arrows: 'splide__arrows absolute w-full h-full flex items-center justify-between',
                            arrow: 'splide__arrow relative flex items-center justify-center z-3 rounded-l-lg w-14 h-16 p-2 bg-black/20 2.5xl:bg-transparent 2.5xl:p-0 2.5xl:w-10 2.5xl:h-12 fill-current text-white disabled:text-white/20 transition-all duration-300 hover:scale-110 disabled:!scale-100',
                            prev: 'splide__arrow--prev left-0 2.5xl:-left-16 rotate-180',
                            next: 'splide__arrow--next right-0 2.5xl:-right-16',
                        },
                    });
                }

                let gallerySplide = null;
                const gallerySplideElement = panel.querySelector('.gallery-splide');
                if (gallerySplideElement) {
                    gallerySplide = new Splide(gallerySplideElement, {
                        type: 'loop',
                        speed: 750,
                        direction: 'ltr',
                        pauseOnHover: true,
                        arrows: true,
                        perPage: 3,
                        perMove: 1,
                        pagination: true,
                        autoplay: false,
                        gap: '2rem',
                        padding: '2rem',
                        destroy: destroySlideDesktop,
                        arrowPath: 'M2.68456 22.7027L30.604 22.7027L17.9866 35.4054C16.9128 36.4865 16.9128 38.1081 17.9866 39.1892C19.0604 40.2703 20.6711 40.2703 21.745 39.1892L39.1946 21.8919C39.1946 21.6216 39.4631 21.3514 39.7315 21.0811C39.7315 20.8108 40 20.5405 40 20C40 19.7297 40 19.1892 39.7315 18.9189C39.4631 18.6487 39.1946 18.3784 39.1946 18.1081L21.745 0.810811C20.6711 -0.27027 19.0604 -0.27027 17.9866 0.810811C16.9128 1.89189 16.9128 3.51351 17.9866 4.59459L30.604 17.2973L2.68456 17.2973C1.07382 17.2973 1.41767e-07 18.3784 0 20C-1.41766e-07 21.6216 1.34228 22.7027 2.68456 22.7027Z',
                        classes: {
                            pagination: 'splide__pagination absolute -bottom-16 left-0 w-full h-12 flex items-center justify-center px-24 gap-1',
                            arrows: 'splide__arrows absolute -bottom-16 left-0 w-full h-12 flex items-center justify-between px-6 lg:px-8',
                            page: 'splide__pagination__page rounded-full overflow-hidden w-3 h-3 bg-opacity-20 hover:scale-105 transition-all duration-150 ease-in-out' + ' ' + paginationColor + ' ' + paginationBorderColor + ' ' + paginationActiveColor,
                            arrow: 'splide__arrow relative z-5 rounded-full w-12 h-12 p-4 fill-current disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 active:!duration-75 active:!scale-125 disabled:!scale-100 disabled:!opacity-20' + ' ' + arrowColor + ' ' + paginationColor,
                            prev: 'splide__arrow--prev rotate-180',
                            next: 'splide__arrow--next',
                        },
                        breakpoints: {
                            1023: {
                                perPage: 3,
                                padding: '1.5rem',
                                gap: '1.5rem',
                                destroy: totalSlides <= 3,
                            },
                            767: {
                                perPage: 2,
                                padding: '1.5rem',
                                gap: '1.5rem',
                                destroy: totalSlides <= 2,
                            },
                            639: {
                                perPage: 1,
                                padding: '1.5rem',
                                gap: '1.5rem',
                                destroy: totalSlides === 1,
                            },
                        },
                    });
                }

                if (lightbox) {
                    const lightboxBackdrop = lightbox.querySelector('[data-lightbox-backdrop]');
                    const lightboxClose = lightbox.querySelector('[data-lightbox-close]');
                    const lightboxProgressBar = lightbox.querySelector('[data-carousel-progress]');

                    // Closes lightbox on backdrop/close button press
                    if (lightboxBackdrop) {
                        lightboxBackdrop.addEventListener('click', () => closeLightBox(lightbox));
                    }
                    if (lightboxClose) {
                        lightboxClose.addEventListener('click', () => closeLightBox(lightbox));
                    }

                    // Updates carousel progress bar width
                    if (lightboxProgressBar && galleryLightboxSplide) {
                        galleryLightboxSplide.on('mounted move', function () {
                            let end = galleryLightboxSplide.Components.Controller.getEnd() + 1;
                            lightboxProgressBar.style.width = String(100 * (galleryLightboxSplide.index + 1) / end) + '%';
                        });
                    }

                    // Closes lightbox on key 'esc' press or navigates slider on keys 'arrowLeft' and 'arrowRight'
                    document.addEventListener('keydown', (e) => documentKeydownHandler(e, lightbox, galleryLightboxSplide));
                }

                // Opens lightbox and navigates carousel to the thumbnail that was pressed
                for ( let thumbnail of galleryThumbnails ) {
                    thumbnail.addEventListener('click', () => {
                        if (thumbnail.dataset.slide.length) {
                            galleryLightboxSplide?.go(parseInt(thumbnail.dataset.slide));
                        }
                        openLightBox(lightbox);
                    });
                }

                galleryLightboxSplide?.mount();
                gallerySplide?.mount()
                gallerySplide?.sync(galleryLightboxSplide);
            }
        }
        // END GALLERY PANEL SLIDER

        // START HOME HERO PANEL SLIDER
        if (homeHeroSplidePanel.length) {
            for ( let panel of homeHeroSplidePanel ) {
                let parentPanel = panel.closest('.home-hero-slide-panel');
                let thumbnailSliders = parentPanel.querySelectorAll('.hero-thumbnails');

                var homeHeroSplide = null;
                var thumbnails = null;
                var thumbnailsMobile = null;

                const homeHeroSplideElement = panel.querySelector('.home-hero-splide');
                if (homeHeroSplideElement) {
                    homeHeroSplide = new Splide(homeHeroSplideElement, {
                        type: 'fade',
                        rewind: true,
                        autoplay: false,
                        drag: false,
                        pauseOnHover : false,
                        pauseOnFocus : false,
                        arrows: false,
                    });
                }

                const heroThumbnailSliderElement = panel.querySelector('.hero-thumbnail-slider');
                if (heroThumbnailSliderElement) {
                    thumbnails = new Splide(heroThumbnailSliderElement, {
                        rewind: false,
                        isNavigation: true,
                        arrows: false,
                        perPage: 3,
                        gap: '2rem',
                        focus: 'left',
                        pagination: false,
                        fixedWidth: '162px',
                        padding: { left: '2rem', right: '2rem' },
                    } );
                }

                const heroThumbnailMobileSliderElement = panel.querySelector('.hero-thumbnail-mobile-slider');
                if (heroThumbnailMobileSliderElement) {
                    thumbnailsMobile = new Splide(heroThumbnailMobileSliderElement, {
                        perMove: 1,
                        updateOnMove: 'true',
                        isNavigation: true,
                        arrows: false,
                        perPage: 3,
                        gap: '1rem',
                        focus: 'left',
                        pagination: false,
                        padding: { left: '1rem', right: '1rem' },
                        flickMaxPages: 1,
                        flickPower: 0.001,
                        breakpoints : {
                            380: {
                                perPage: 2.2,
                            },
                            540: {
                                perPage: 2.5,
                            },
                        },
                    } );
                }

                homeHeroSplide?.on('mounted move', function () {
                    let pageHeader = document.getElementById('headerNavigationMenu');
                    let headerLogos = pageHeader.querySelectorAll('.header-desktop-artrage-logo');
                    for ( let headerLogo of headerLogos ) {
                        if (homeHeroSplide.index !== 0) {
                            headerLogo.classList.remove('lg:opacity-0')
                        } else {
                            headerLogo.classList.add('lg:opacity-0')
                        }
                    }
                });

                for (let thumbnailSlider of thumbnailSliders) {
                    let thumbnailSlidesWithLinks = thumbnailSlider.querySelectorAll('.contains-link');
                    for (let thumbnailSlide of thumbnailSlidesWithLinks) {
                        thumbnailSlide.addEventListener('click', (event) => {
                            if (thumbnailSlide.classList.contains('is-active')) {
                                window.location = thumbnailSlide.getAttribute('data-card-link');
                            }
                        });
                    }
                }

                homeHeroSplide?.sync( thumbnails );
                homeHeroSplide?.sync( thumbnailsMobile );
                homeHeroSplide?.mount();
                thumbnails?.mount();
                thumbnailsMobile?.mount();
            }
        }
        // END HOME HERO PANEL SLIDER

        // START DATE SELECTOR SLIDER
        if (eventSelectorPanel.length) {
            let elementIndex = 0;
            if (window.location.hash.length > 1) {
                const performanceRef = window.location.hash.substring(1);
                const performanceSplide = document.querySelector(`li.splide__slide[data-performance="${performanceRef}"]`);

                if (performanceSplide) {
                    const siblings = [...performanceSplide.parentElement.children];
                    elementIndex = siblings.indexOf(performanceSplide);
                }
            }

            for ( let panel of eventSelectorPanel ) {
                let parentPanel = panel.closest('.event-selector-panel');

                let slideButtons = parentPanel.querySelectorAll('.splide__slide');
                const splideDateSelector = panel.querySelector('.splide-date-selector');
                if (splideDateSelector) {
                    let dateSelectorSplide = new Splide(splideDateSelector, {
                        start: elementIndex,
                        type: 'slide',
                        gap: '1rem',
                        autoWidth: 'true',
                        pagination: false,
                        perMove: 1,
                        arrows: true,
                        updateOnMove: true,
                        padding: { left: '1rem', right: '1rem' },
                        classes: {
                            arrows: 'splide__arrows absolute w-[6rem] h-max flex items-center justify-between flex top-0 gap-4 right-4 sm:right-6 lg:right-8',
                            arrow : 'splide__arrow relative z-5 bg-transparent p-0 w-10 h-12 fill-current text-white disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 disabled:!scale-100',
                            prev  : 'splide__arrow--prev rotate-180',
                            next  : 'splide__arrow--next',
                        },
                    });

                    dateSelectorSplide.mount();

                    for ( let button of slideButtons ) {
                        button.addEventListener('click', (event) => {
                            dateSelectorSplide.go(parseInt(button.getAttribute('data-loopindex')));
                        });
                    }
                }

                const dateSelectors = parentPanel.querySelectorAll('button[data-ticketing][data-date]');
                const performanceAccordions = parentPanel.querySelectorAll('div.performance-cards > div');
                let nextButtons = parentPanel.querySelectorAll('.splide__arrow--next');
                let prevButtons = parentPanel.querySelectorAll('.splide__arrow--prev');

                function showHideDates() {
                    for (let dateSelector of dateSelectors) {
                        dateSelector.classList.remove('selected');
                        dateSelector.ariaSelected = 'false';
                    }
                    setTimeout(() => {
                        let newActive = panel.querySelector('.splide__slide.is-active > button');
                        if (newActive) {
                            newActive.classList.add('selected');
                            newActive.ariaSelected = 'true';

                            const selectedDate = newActive.getAttribute('data-date');
                            const datePerformanceCount = [...performanceAccordions].filter((performanceAccordion) => performanceAccordion.querySelector('button[data-date]').getAttribute('data-date') === selectedDate).length;

                            performanceAccordions.forEach((performanceAccordion) => {
                                const performanceCard = performanceAccordion.querySelector('button[data-date]');
                                const accordionContent = performanceAccordion.querySelector('.accordion-content');

                                if (performanceCard.getAttribute('data-date') === selectedDate) {
                                    performanceAccordion.classList.remove('hidden');
                                    performanceCard.classList.remove('hidden');

                                    const displayPricebands = datePerformanceCount > 1;

                                    if (!displayPricebands && accordionContent) {
                                        setAccordionCrossClasses(performanceAccordion,true);
                                        accordionContent.classList.remove('!max-h-[0]', 'hidden', 'opacity-0');
                                    }
                                } else {
                                    setAccordionCrossClasses(performanceAccordion,false);
                                    performanceAccordion.classList.add('hidden');
                                    performanceCard.classList.add('hidden');
                                    if (accordionContent) {
                                        accordionContent.classList.add('!max-h-[0]', 'hidden', 'opacity-0');
                                    }
                                }
                            });
                        }
                    }, 50);
                }

                showHideDates();

                for ( let button of nextButtons ) {
                    button.addEventListener('click', (event) => {
                        showHideDates();
                    });
                }


                for ( let button of prevButtons ) {
                    button.addEventListener('click', (event) => {
                        showHideDates();
                    });
                }
            }
        }
        // END DATE SELECTOR SLIDER

        // START CARD PANEL SLIDER
        for ( const panel of cardPanel ) {
            const totalSlides = parseInt(panel.querySelector('.card-panel-splide').dataset.totalSlides);
            const paginationColor = panel.querySelector('.card-panel-splide').dataset.paginationColor;
            const paginationBorderColor = panel.querySelector('.card-panel-splide').dataset.paginationBorderColor;
            const arrowColor = panel.querySelector('.card-panel-splide').dataset.arrowColor;

            const cardPanelSplideElement = panel.querySelector('.card-panel-splide');
            if (cardPanelSplideElement) {
                const cardSplide = new Splide(cardPanelSplideElement, {
                    type: 'slide',
                    speed: 750,
                    direction: 'ltr',
                    pauseOnHover: true,
                    arrows: true,
                    perPage: 3,
                    pagination: false,
                    autoplay: false,
                    gap: '2rem',
                    padding: '2rem',
                    interval: 10000,
                    destroy: totalSlides <= 3,
                    classes: {
                        pagination: 'splide__pagination flex justify-center items-center gap-2 w-max !mx-auto pb-2 sm:!mr-6 sm:!mr-8 !hidden',
                        page: 'splide__pagination__page rounded-full overflow-hidden w-3 h-3 opacity-50 hover:scale-105 [&.is-active]:opacity-100 transition-all duration-150 ease-in-out border' + ' ' + paginationColor + ' ' + paginationBorderColor,
                        arrows: 'splide__arrows absolute w-full sm:w-max h-max px-4 sm:px-0 flex items-center justify-between flex bottom-0 left-0 sm:bottom-[unset] sm:left-[unset] sm:top-2 lg:top-0 sm:right-6 lg:right-8 gap-4',
                        arrow: 'splide__arrow relative z-5 p-3 w-12 h-12 fill-current disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 active:!duration-75 active:!scale-125 disabled:!scale-100' + ' ' + arrowColor + ' ' + paginationColor,
                        prev: 'splide__arrow--prev rotate-180',
                        next: 'splide__arrow--next',
                    },
                    breakpoints: {
                        1023: {
                            perPage: 2,
                            padding: '1.5rem',
                            gap: '1.5rem',
                            destroy: totalSlides <= 2,
                        },
                        767: {
                            perPage: 1,
                            padding: '1.5rem',
                            gap: '1.5rem',
                            destroy: totalSlides === 1,
                        },
                        639: {
                            perPage: 1,
                            padding: '1rem',
                            gap: '1.5rem',
                            destroy: totalSlides === 1,
                        },
                    },
                });

                cardSplide.mount();
            }
        }
        // END CARD PANEL SLIDER
    }
});
